<template>
  <!-- 规则弹窗 -->
  <div class="rulebtn">
    <div class="vowRule left">
      <img @click="showRule" class="ruleBtn" src="../../static/images/activity_rule.png" alt />
      <img @click="contact" class="ruleBtn2" src="../../static/images/activity_contact.png" alt />
    </div>
    <div class="vowRule">
      <img @click="goteam" class="ruleBtn" src="../../static/images/activity_reward.png" alt />
      <img @click="goRank" class="ruleBtn2" src="../../static/images/activity_rank.png" alt />
    </div>
    <RulePopup @closeRule="showRule" :show="isshowrule" :ruleText="activityInfo.rule_desc"></RulePopup>
      <!-- 联系客服 -->
    <CustomerServece v-if="cservece==true" @closeCS="closeCS"></CustomerServece>
  </div>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";
import RulePopup from "../components/RulePopup.vue";
import CustomerServece from "../components/CustomerServece.vue";
Vue.use(Popup);
export default {
  name: "rulebtn",
  props: ["myuser", "fromType"],
  data() {
    return {
      isshowrule: false,
      cservece:false,//是否显示联系客服
    };
  },
  mounted() {
    // console.warn("ssljkljsl" + this.ruleText);
  },
  methods: {
    //子组件 向父组件传值。
    closeModal(statu) {
      this.$emit("closeRule", statu);
    },
    // 联系客服
    contact() {
       this.cservece = true;
    },
    // 去排行榜
    goRank() {
      var t = this;
      t.$router.push({
        path: "/ranklist",
        query: {}
      });
    },
    // 查看活动规则
    showRule() {
      var t = this;
      t.isshowrule = !t.isshowrule;
      t._deepmain(t.pageId, "homepage2#rules", 2);
    },
    // 查看我的奖品
    goteam() {
      var t = this;
      // fromType:1-抽奖页面过来 0-许愿首页过来
      if (t.fromType == 1) {
        t._deepmain(t.pageId, "homepage2#award", 2);
      } else {
        t._deepmain(this.pageId, "homepage1#award", 2);
      }
      if (t.myuser.isbindtel == 0) {
        //奖励列表 必须绑定手机号。
        this.$emit("showPhone", true);
        return;
      }
      t.$router.push({
        path: "/team",
        query: {}
      });
    }, 
    //关闭联系客服弹窗
    closeCS(statu){
      this.cservece = statu;
    }
  },
  components: { RulePopup ,CustomerServece}
};
</script>

<style scoped lang="scss" src="../../static/scss/vow.scss"></style>

<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>
